import { FlexBox, Text } from '@trmediaab/zebra';
import { useWindowSize } from '@trmediaab/zebra-hooks';
import groupBy from 'lodash/groupBy';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectPremium } from '~/containers/Auth/selectors';

import StartlistCompact from './StartlistCompact';
import StartlistLarge from './StartlistLarge';
import { VARIANT_THRESHOLDS } from './utils';

export const DistanceRow = ({ distance }) => (
  <FlexBox
    alignItems="center"
    px="3"
    bg="brands.travrondenSpel"
    gridColumn="1/-1"
    height="36px"
  >
    <Text fontSize="1" fontWeight="bold" color="white">
      Tillägg: {distance} meter
    </Text>
  </FlexBox>
);

const Startlist = ({ race, betType, hasPremium }) => {
  const { width: windowWidth } = useWindowSize();
  const startsByDistance = groupBy(race.starts, s => s.extra_dist ?? 0);
  const StartListComponent =
    windowWidth > VARIANT_THRESHOLDS.mobile ? StartlistLarge : StartlistCompact;

  return (
    <StartListComponent
      startsByDistance={startsByDistance}
      betType={betType}
      windowWidth={windowWidth}
      hasPremium={hasPremium}
    />
  );
};

Startlist.propTypes = {
  race: PropTypes.object.isRequired,
  betType: PropTypes.string,
  hasPremium: PropTypes.bool,
};

export default connect(
  createStructuredSelector({
    hasPremium: selectPremium,
  }),
)(Startlist);
